import { Dispatch, RefObject } from "react";
import { react } from "uikit";

import MaibPaymentsCurrency from "./components/MaibPaymentsCurrency";
import MaibPaymentsCountryIso from "./components/MaibPaymentsCountryIso";

interface Context {
	// maibPaymentsProcessingId: number;
	maibPaymentsSecretKey: string;
	maibPaymentsKey: string;
	maibSignatureId: string;
	currencyRef: RefObject<MaibPaymentsCurrency.Ref | null>;
	countryIsoRef: RefObject<MaibPaymentsCountryIso.Ref | null>;
	// setMaibProcessingIdError: Dispatch<boolean>;
	setMaibPaymentsKeyError: Dispatch<boolean>;
	setMaibPaymentsSecretKeyError: Dispatch<boolean>;
	setMaibSignatureIdError: Dispatch<boolean>;
}

export default class Controller extends react.ControllerBase<Context> {
	validate() {
		const isCurrency = this.context?.currencyRef.current?.validate();
		const isCountryIso = this.context?.countryIsoRef.current?.validate();
		// const isMaibPaymentsProcessingId =
		// 	!!this.context?.maibPaymentsProcessingId;
		const isMaibPaymentsSecretKey =
			!!this.context?.maibPaymentsSecretKey.trim();
		const isMaibPaymentsKey = !!this.context?.maibPaymentsKey.trim();
		const isMaibSignatureId = !!this.context?.maibSignatureId.trim();

		// if (!isMaibPaymentsProcessingId) {
		// 	this.context?.setMaibProcessingIdError(true);
		// }

		if (!isMaibPaymentsKey) {
			this.context?.setMaibPaymentsKeyError(true);
		}

		if (!isMaibSignatureId) {
			this.context?.setMaibSignatureIdError(true);
		}

		if (!isMaibPaymentsSecretKey) {
			this.context?.setMaibPaymentsSecretKeyError(true);
		}

		return [
			isCurrency,
			isCountryIso,
			// isMaibPaymentsProcessingId,
			isMaibPaymentsKey,
			isMaibSignatureId,
			isMaibPaymentsSecretKey,
		].every((isValid) => isValid);
	}
}
